// >>> R59's SAVE-SHELF LAW, OUT WHERE SOMETHING CAN IMPORT IT (R8, paid by BREACH-1). <<<
//
// It has THREE call sites in App.tsx and lived inside it, so nothing could reach it. Its law is
// R59's and it is the kind that has already cost this house something: **`null` STAYS `null`** —
// the *not loaded yet* state W5-2/R39 built, and the catch that once set it to an empty array
// flipped every save chip in the Library from HOLDING STILL to saying "not saved" about books
// that ARE saved. A law with three callers and no importer is a law no gate can run.
import { useEffect, useState } from "react";
import { listSavedBooks, SAVED_BOOKS_URL, saveMethod } from "../lib/saved-books";

export function useSavedShelf() {
  const [slugs, setSlugs] = useState<string[] | null>(null);
  const load = () =>
    // R59: **null STAYS null.** It is the "not loaded yet" state W5-2/R39 built, and the old
    // catch that set it to an empty array flipped every save chip in the Library from holding
    // still to saying "not saved" about books that ARE saved.
    listSavedBooks<{ slug: string }>().then((rows) => { if (rows) setSlugs(rows.map((b) => b.slug)); });
  useEffect(() => { load(); }, []);
  const toggle = (slug: string) => {
    const on = (slugs || []).includes(slug);
    setSlugs((current) => (on ? (current || []).filter((s) => s !== slug) : [...(current || []), slug]));
    fetch(SAVED_BOOKS_URL, {
      method: saveMethod(!on),
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ slug }),
    })
      .then((r) => { if (!r.ok) setSlugs((current) => (on ? [...(current || []), slug] : (current || []).filter((s) => s !== slug))); })
      .catch(() => setSlugs((current) => (on ? [...(current || []), slug] : (current || []).filter((s) => s !== slug))));
  };
  return {
    // `null` until the server has answered: the button holds still rather than claiming "not saved".
    isSaved: (slug: string) => (slugs === null ? null : slugs.includes(slug)),
    toggle,
    reload: load,
  };
}
